module.exports = __webpack_public_path__ + "d257c97b1e6a9a8d4890c53b25806ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/va.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/va.svg
// module chunks = 0